import React, { useEffect, useState } from 'react';
import { Flag, Menu, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { PAYPAL_URL } from '../utils/donate';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Mission',
    href: '/#mission'
  }, {
    name: 'Commitments',
    href: '/#commitments'
  }, {
    name: 'Issues',
    href: '/#issues'
  }, {
    name: 'Coalition',
    href: '/#coalition'
  }, {
    name: 'Leadership',
    href: '/#leadership'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-pac-navy/95 backdrop-blur-md shadow-lg py-3' : 'bg-pac-navy py-5'}`} data-id="element-214" data-mp="1kyonmdhfuwq7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215" data-mp="emj4491j3n41">
        <div className="flex justify-between items-center" data-id="element-216" data-mp="jmnjtwum4dt7">
          <Link to="/" className="flex items-center gap-2" aria-label="AZ City PAC home" data-id="element-217" data-mp="jn6vwwxl07zb">
            <Flag className="h-8 w-8 text-pac-gold" data-id="element-218" data-mp="3n3dsyklhr6z4" />
            <div className="flex flex-col" data-id="element-219" data-mp="3n4xcql6cw05n">
              <span className="font-serif font-bold text-xl leading-tight text-white tracking-wide uppercase" data-id="element-220" data-mp="3s2gsxqmm6n08">
                AZ City
              </span>
              <span className="text-[10px] font-sans font-semibold text-pac-gold tracking-[0.2em] uppercase" data-id="element-221" data-mp="ul36lhz0xiy">
                Political Action Committee
              </span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-8" aria-label="Primary navigation" data-id="element-222" data-mp="34cmfp7yduwfg">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-200 hover:text-white transition-colors uppercase tracking-wider" data-id="element-223" data-mp="31a883gvqut5h">
                {link.name}
              </a>)}
            <Link to="/news" className="text-sm font-medium text-slate-200 hover:text-white transition-colors uppercase tracking-wider" data-id="element-224" data-mp="361giog8t8kk8">
              News
            </Link>
            <a href={PAYPAL_URL} target="_blank" rel="noopener noreferrer" className="bg-pac-red hover:bg-red-800 text-white px-6 py-2.5 rounded font-bold tracking-wider uppercase transition-all shadow-[0_0_15px_rgba(185,28,28,0.5)] hover:shadow-[0_0_25px_rgba(185,28,28,0.8)] transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2 focus:ring-offset-pac-navy" data-id="element-225" data-mp="2dedv2j5o9u8r">
              Donate Now
            </a>
          </nav>

          <button type="button" className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" aria-expanded={mobileMenuOpen} data-id="element-226" data-mp="a6vcyyz5zumj">
            {mobileMenuOpen ? <X className="h-6 w-6" data-id="element-227" data-mp="567lkc70xbrs" /> : <Menu className="h-6 w-6" data-id="element-228" data-mp="surzy3gkvq4v" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-229" data-mp="xuwevp1u8csz">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-pac-navy border-t border-slate-800 overflow-hidden" data-id="element-230" data-mp="xwhazj3sw3sy">
            <nav className="px-4 py-6 flex flex-col gap-4" aria-label="Mobile navigation" data-id="element-231" data-mp="1gm5sa9eqblpu">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-slate-200 hover:text-white uppercase tracking-wider block py-2" data-id="element-232" data-mp="3k22mp3aim4pn">
                  {link.name}
                </a>)}
              <Link to="/news" onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-slate-200 hover:text-white uppercase tracking-wider block py-2" data-id="element-233" data-mp="6nxvyclz8gpu">
                News
              </Link>
              <a href={PAYPAL_URL} target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)} className="bg-pac-red text-white px-6 py-4 rounded font-bold tracking-wider uppercase text-center mt-4" data-id="element-234" data-mp="3u0rws9w66kvc">
                Donate Now
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}